import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createNamespace } from "../redux/createNamespace";
import { CloseEventReason, SocketStatus } from "./webSocketStatus";
import type { CloseEventReasonType, SocketStatusType } from "./webSocketStatus";

const initialState: {
  status: SocketStatusType;
  closeEventReason: CloseEventReasonType;
} = {
  status: SocketStatus.INITIAL,
  closeEventReason: CloseEventReason.UNSPECIFIED,
};

export const {
  actions: { setConnectionStatus, setCloseEventReason },
  reducer,
} = createSlice({
  name: createNamespace("socket"),
  initialState,
  reducers: {
    setConnectionStatus: (state, action: PayloadAction<SocketStatusType>) => {
      state.status = action.payload;
    },
    setCloseEventReason: (
      state,
      action: PayloadAction<CloseEventReasonType>,
    ) => {
      state.closeEventReason = action.payload;
    },
  },
});
